export const MedicalConfiguration = {
    path: '/medical_configuration',
    name: 'medical_configuration',
    component: () => import('@/views/Evaluation/EvaluationConfiguration.vue'),
}